import { render, staticRenderFns } from "./exchangeVideoVipByLaws.vue?vue&type=template&id=ae58fbde&scoped=true&"
import script from "./exchangeVideoVipByLaws.vue?vue&type=script&lang=js&"
export * from "./exchangeVideoVipByLaws.vue?vue&type=script&lang=js&"
import style0 from "./exchangeVideoVipByLaws.vue?vue&type=style&index=0&id=ae58fbde&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae58fbde",
  null
  
)

export default component.exports